import { Link } from 'react-router-dom';
import { allReviews, getMovieById } from '@/lib/data';
import SectionTitle from '@/components/base/SectionTitle';

const featuredReviewIds = ['r1-1', 'r4-1', 'r30-1', 'r21-1'];

export default function ReviewsSection() {
  const list = allReviews.filter((r) => featuredReviewIds.includes(r.id));

  return (
    <section className="mt-14">
      <SectionTitle
        eyebrow="Reviews"
        icon="ri-quill-pen-line"
        title="近期影评精选"
        description="多篇深度影评摘要，从叙事、影像与主题三个层面解读作品。"
        moreTo="/special"
        moreLabel="查看影评专题"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
        {list.map((r) => {
          const movie = getMovieById(r.movieId);
          return (
            <Link
              key={r.id}
              to={`/detail/${r.movieId}`}
              className="group flex gap-4 rounded-lg border border-background-200/80 bg-background-50 p-4 md:p-5 hover:border-accent-300 transition-colors cursor-pointer"
            >
              <div className="hidden sm:block w-24 h-32 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={movie?.cover}
                  alt={`${movie?.title} 封面`}
                  title={`${movie?.title} 影评`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {r.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">{r.excerpt}</p>
                <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-user-3-line" aria-hidden="true" />
                    {r.author}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-calendar-line" aria-hidden="true" />
                    {r.date}
                  </span>
                  {movie && (
                    <span className="inline-flex items-center gap-1 text-primary-600">
                      <i className="ri-film-line" aria-hidden="true" />
                      《{movie.title}》
                    </span>
                  )}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}